import * as React from 'react';
import { format } from 'date-fns';
import NextImage from 'next/image';
import { Author } from 'constants/blog';
import { getArticlePageUrl } from 'constants/pages';
import ArrowRight from 'svg/ArrowRight';
import { Button } from 'components/Button';
import Link from 'components/Link';
import Tag from 'components/blog/Tag';

export default function PreviewPost(props: {
  title: string;
  image: string;
  author: Author;
  previewText: string;
  createdAt: string;
  tags: string[];
  id: string;
  slug: string;
}) {
  const { id, slug, image, tags, previewText, author, title, createdAt } = props;

  return (
    <div className="mx-auto mt-10 flex max-w-[1200px] flex-col px-6 pb-10 md:mt-20 md:flex-row md:pb-20 lg:px-0">
      <div className="md:w-1/2">
        <Link href={getArticlePageUrl(slug)}>
          <NextImage
            src={image}
            alt={title}
            className="w-full rounded-lg object-cover object-center xs:h-[13.75rem] md:h-[21.5rem]"
            loading="lazy"
            width={544}
            height={344}
          />
        </Link>
      </div>
      <div className="mt-6 md:ml-8 md:mt-0 md:w-1/2">
        <Link href={getArticlePageUrl(slug)}>
          <div className="flex-wrap pb-8 xs:hidden md:flex">
            {tags?.map((tag: string, index) => (
              <Tag
                text={tag}
                key={index}
                className={
                  'me-2 rounded-full bg-color-bg-darkmode-secondary px-3 py-1 text-xs text-color-text-darkmode-primary md:me-3 md:text-sm'
                }
                appendClasses={false}
              />
            ))}
          </div>
          <p className="pb-4 text-sm font-medium text-color-text-darkmode-primary">
            {author?.name} • {format(new Date(createdAt), 'd LLL yyyy')}
          </p>
          {/**
           * @note since this section is black in both light and dark mode, we only need one font color
           */}
          <h2 className="typography-product-heading-compact-desktop md:typography-informative-heading-compact-desktop mb-4 leading-normal text-color-text-lightmode-invert">
            {title}
          </h2>
          <p className="pb-8 text-color-text-darkmode-primary xs:text-sm md:text-base">
            {previewText}
          </p>
          {!!tags && (
            <div className="flex-wrap pb-8 xs:flex md:hidden">
              {tags.map((tag: string, index) => (
                <Tag
                  text={tag}
                  key={index}
                  className={
                    'me-2 rounded-full bg-color-bg-darkmode-secondary px-3 py-1 text-xs text-color-text-darkmode-primary md:me-3 md:text-sm'
                  }
                  appendClasses={false}
                />
              ))}
            </div>
          )}
          <Button
            variant="primary"
            className="hidden h-10 items-center justify-center rounded-3xl border border-white xs:w-24 md:flex"
            iconLeft={<ArrowRight className="mr-1 h-5 w-5" />}
          >
            Read
          </Button>
        </Link>
      </div>
    </div>
  );
}
